<script lang="ts" setup>
import { login } from '@/auth/keycloak';

function enterAnalytics() {
  login();
}
</script>

<template>
  <div id="landing-page">
    <!-- Row 1: centered landing content -->
    <div id="landing-content">
      <img
        src="@/assets/images/logo-light.svg"
        class="logo mt-3"
        alt="Sampling Human"
      /><br />
      <button class="btn enter" @click="enterAnalytics">
        <i class="fa fa-line-chart"></i> Enter Analytics Cloud
      </button>
      <p class="links">
        or go to
        <a href="https://samplinghuman.com" class="user">samplinghuman.com</a>
      </p>
    </div>
    <!-- Row 2: Compliance & Feature Icons -->
    <div
      id="compliance-content"
      class="d-flex flex-wrap justify-content-center"
    >
      <!-- Disable all compliance icons for now
      <img
        src="@/assets/images/icon-compliance-hipaa.png"
        alt="HIPAA Compliance"
      />
      <img src="@/assets/images/icon-compliance-gdpr.png" alt="Compliance" />
      <img
        src="@/assets/images/icon-compliance-cal.png"
        alt="CalOPPA, CCPA and CPRA Compliance"
      />-->
      <img
        src="@/assets/images/icon-illumina-basespace.png"
        alt="Illumina BaseSpace Sequence Hub Integration"
      />
    </div>
  </div>
</template>

<style scoped>
#compliance-content {
  display: flex;
  justify-content: center;
  gap: 25px;
  padding: 1rem;
}
#compliance-content img {
  width: 100px;
  height: auto;
  opacity: 0.5;
  transition: opacity 1s;
}
#compliance-content img:hover {
  opacity: 1;
}
</style>
